import { createAction, props } from '@ngrx/store';
import { QuestionMaster } from '../../../core/models/question-master/question-master.model';

export const loadQuestionMasterRecords = createAction('[Question Master Facade] Load Question Master Records');
export const loadQuestionMasterRecordsSuccess = createAction(
    '[Question Master Effects] Load Question Master Records Success',
    props<{ questionMasterRecords: Array<QuestionMaster> }>()
);
